import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// Variants follow the design system (primitives.css .is-btn): filled tones, no outlines, no resting shadows.
// "outline" is kept as a name for existing callers and renders as the secondary tone.
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-[length:var(--fs-sm)] font-[550] transition-[background-color,color,transform] duration-100 active:translate-y-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-ring)] disabled:pointer-events-none disabled:opacity-[0.55] [&_svg]:pointer-events-none [&_svg]:size-[15px] [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[var(--accent-from)] text-[var(--text-on-accent)] hover:bg-[var(--accent-to)]",
        destructive:
          "bg-[var(--state-critical-strong)] text-[var(--text-on-strong)] hover:brightness-110",
        outline:
          "bg-[var(--surface-4)] text-[var(--text-primary)] hover:bg-[var(--surface-3)]",
        secondary:
          "bg-[var(--surface-4)] text-[var(--text-primary)] hover:bg-[var(--surface-3)]",
        ghost: "text-[var(--text-secondary)] hover:bg-[var(--surface-3)] hover:text-[var(--text-primary)]",
        link: "text-[var(--text-link)] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4",
        sm: "h-8 px-3",
        lg: "h-10 px-6",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
